import { Col, Row, Table } from "antd";
import { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import styled from "styled-components";
import { layTenTienDoKPI, trangThaiKPI } from '../../constants';
import { dateCommon } from "../../helpers/common";
import { ChiTietKPICaNhan } from "../../models/kpi/KPICaNhan";

const PrintPage = styled.div`
  @media print {
    /* Thiết lập lề và kích thước giấy A4 */
    @page {
      size:landscape;
      background-color: white;
      margin-top: 2cm;
      margin-bottom: 2cm;
      margin-left: 1cm;
      margin-right: 1cm;
    }
    div {
      font-family:'Times New Roman',Times,serif !important;
    }
    label {
      font-family:'Times New Roman',Times,serif !important;
    }
    
  }
`;

const InKPICaNhan = ({ KPICaNhan }: { KPICaNhan: any }) => {
    const [cong, setCong] = useState([0, 0, 0]);
    const [diemThuong, setDiemThuong] = useState([0, 0, 0]);
    const [dataTable, setDataTable] = useState<any>();
    const now = new Date();

    const user = useSelector((state: any) => state.auth.currentUser);
    const dataDiemChuan = [
        {
            key: '1',
            STT: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(1)</label>,
            noiDung: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(2)</label>,
            thoiGianGV: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(3)</label>,
            thoiGianYC: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(4)</label>,
            tot: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(5a)</label>,
            saiSot: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(5b)</label>,
            tienDo: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(6)</label>,
            banThan: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(7)</label>,
            chanhVP: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(8)</label>,
            lanhDaoPhuTrach: <label className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(9)</label>,
        },
        {
            key: '2',
            noiDung: <label style={{ fontFamily: 'Times New Roman' }}>Điểm chuẩn</label>,
            banThan: <label style={{ fontFamily: 'Times New Roman' }}>100</label>,
            chanhVP: <label style={{ fontFamily: 'Times New Roman' }}>100</label>,
            lanhDaoPhuTrach: <label style={{ fontFamily: 'Times New Roman' }}>100</label>,
        },
    ];

    type dataType = {
        key: any,
        noiDung?: any,
        thoiGianGV?: any,
        thoiGianYC?: any,
        tot?: any,
        saiSot?: any,
        tienDo?: any,
        banThan?: any,
        chanhVP?: any,
        lanhDaoPhuTrach?: any,
        ghiChu?: any,
        STT?: any,
        isTieuDe: number
    };

    const layDuLieu = async () => {
        var data: any[] = [...dataDiemChuan];
        var tuDanhGia = 0;
        var lanhDaoPhong = 0;
        var lanhDaoPhuTrach = 0;
        KPICaNhan.nhomKPI.map((item: any, index: any) => {
            if (item.chiTiet != null && item.chiTiet.length != 0) {
                data.push({
                    key: item.ten + item.id,
                    STT: item.id == 1 ? <label style={{ fontFamily: 'Times New Roman' }}>A</label > : item.id == 2 ? <label style={{ fontFamily: 'Times New Roman' }}>B</label > : <label style={{ fontFamily: 'Times New Roman' }}>C</label>,
                    noiDung: item.id == 1 ? <label style={{ fontFamily: 'Times New Roman' }}>Về công tác chuyên môn</label> : item.id == 2 ? <label style={{ fontFamily: 'Times New Roman' }}>Về chấp hành nội quy/quy chế cơ quan</label > : <label style={{ fontFamily: 'Times New Roman' }}>Về điểm cộng (05 điểm/mục)</label>,
                    banThan: item.tuDanhGia,
                    chanhVP: KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhong && !user.isLanhDaoPhong ? item.lanhDaoPhong : "",
                    lanhDaoPhuTrach: KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhuTrach && item.lanhDaoPhuTrach,
                    isTieuDe: 0
                });
                if (item.chiTiet != null) {
                    item.chiTiet.map((_item: ChiTietKPICaNhan, index2: any) => {
                        data.push({
                            STT: _item.isTieuDe == 1 ? <label>{_item.thuTuStr}</label> : _item.thuTuStr,//index2 + 1,
                            key: _item.tenCongViec + _item.id,
                            noiDung: _item.isTieuDe == 1 ? <label>{_item.tenCongViec}</label> : _item.tenCongViec,
                            thoiGianGV: dateCommon.formatDate(_item.thoiGianGiao, "dd/MM/yyyy"),
                            thoiGianYC: dateCommon.formatDate(_item.thoiGianYeuCauHoanThanh, "dd/MM/yyyy"),
                            tot: (_item.chatLuong != null && _item.chatLuong != 0) ? "x" : "",
                            saiSot: (_item.chatLuong != null && _item.chatLuong == 0) ? "x" : "",
                            tienDo: _item.tienDo == null ? "" : layTenTienDoKPI(_item.tienDo),
                            ghiChu: _item.ghiChu,
                            banThan: (_item.diemCaNhan || 0) != 0 ? _item.diemCaNhan : "",
                            chanhVP: user.isLanhDaoPhong ? "" : ((_item.diemLanhDaoPhong || 0) != 0 ? _item.diemLanhDaoPhong : ""),
                            lanhDaoPhuTrach: (_item.diemLanhDaoPhuTrach || 0) != 0 ? _item.diemLanhDaoPhuTrach : "",
                            isTieuDe: _item.isTieuDe
                        });
                    })
                }
                if (item.id != 3) {
                    tuDanhGia += item.tuDanhGia;
                    lanhDaoPhong += item.lanhDaoPhong;
                    lanhDaoPhuTrach += item.lanhDaoPhuTrach;
                }
                else {
                    setDiemThuong([item.tuDanhGia, item.lanhDaoPhong, item.lanhDaoPhuTrach])
                }
                setCong([tuDanhGia, lanhDaoPhong, lanhDaoPhuTrach])
            }            
        })
        setDataTable(data);
    }

    const columns: ColumnsType<dataType> = [
        {
            title: 'STT',
            dataIndex: 'STT',
            key: 'STT',
            width: '3%',
            align:'center'
        },
        {
            title: 'Nội dung',
            dataIndex: 'noiDung',
            key: 'noiDung',
            width: '24%',
            align: 'left',
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 6 : 1
            }),
        },
        {
            title: 'Thời gian giao việc',
            dataIndex: 'thoiGianGV',
            key: 'thoiGianGV',
            width: '10%',
            align: 'center',
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
        },
        {
            title: 'Thời gian yêu cầu hoàn thành',
            dataIndex: 'thoiGianYC',
            key: 'thoiGianYC',
            align: "center",
            width: '10%',
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
        },
        {
            title: 'Chất lượng',
            key: 'chatLuong',
            width:'10%',
            align: 'center',
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            children: [
                {
                    title: 'Tốt',
                    dataIndex:'tot',
                    key: 'tot',
                    width: '3%',
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    align: 'center'
                },
                {
                    title: 'Sai sót /Chỉnh sửa',
                    dataIndex:'saiSot',
                    key: 'saiSot',
                    align: 'center',
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    width:'7%'
                }
            ]
        },
        {
            title: 'Tiến độ thực hiện (Trước/ Đúng / Trễ)',
            dataIndex: 'tienDo',
            key: 'tienDo',
            align: 'center',
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            width: '13%'
        },
        {
            title: 'Chấm điểm (điểm trừ, điểm cộng)',
            key: 'chamDiem',
            width: '20%',
            align: 'center',
            children: [
                {
                    title: 'Bản thân',
                    dataIndex: 'banThan',
                    width: '5%',
                    align: 'center',
                    key: 'banThan',
                },
                {
                    title: 'Lãnh đạo phòng',
                    dataIndex: 'chanhVP',
                    width: '7%',
                    align: 'center',
                    key: 'chanhVP',
                },
                {
                    title: 'Lãnh đạo phụ trách phòng',
                    dataIndex: 'lanhDaoPhuTrach',
                    width: '8%',
                    align: 'center',
                    key: 'lanhDaoPhuTrach',
                }
            ]
        },
        {
            title: 'Ghi chú',
            dataIndex: 'ghiChu',
            key: 'ghiChu',
            align: 'center',
            width: '10%'
        },
    ];

    const layXepLoai = (diem: any) => {
        if (diem > 100) {
            return "A+";
        }
        else if (diem >= 96 && diem <= 100) {
            return "A";
        }
        else if (diem >= 85 && diem <= 95) {
            return "B";
        }
        else if (diem < 85) {
            return "C";
        }
        else {
            return "";
        }
    }

    useEffect(() => {
        if(KPICaNhan != null){
            layDuLieu();
        }
    }, [KPICaNhan])

    return (
        <section>
            <div style={{ backgroundColor: 'white' }}>
                <PrintPage >
                    <div className="text-center pt-2">
                        <Row gutter={8}>
                            <Col span={12} >
                                <label style={{ fontFamily: 'Times New Roman' }}>QUỸ ĐẦU TƯ PHÁT TRIỂN THÀNH PHỐ ĐÀ NẴNG <br /> <span style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan?.nguoiBaoCao?.tenDonVi?.toUpperCase()}</span><hr style={{ borderTop: "1px solid", width: "20%", marginLeft: '36mm', marginTop: "1px", marginBottom: "2px" }} /> <br /> Họ và tên: {KPICaNhan?.tenNhanVien}</label>
                            </Col>
                            <Col span={12}  >
                                <label style={{ fontFamily: 'Times New Roman' }}>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM <br /> <span style={{ fontFamily: 'Times New Roman' }}>Độc lập - Tự do  - Hạnh phúc</span><hr style={{ borderTop: "1px solid", width: "50%", marginLeft: '18mm', marginTop: "1px", marginBottom: "2px" }} /> </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} className="pt-4">
                                <label style={{ fontFamily: 'Times New Roman' }}>BẢNG ĐÁNH GIÁ KẾT QUẢ CÔNG VIỆC <br /> Tháng {dateCommon.formatDate(KPICaNhan.thangNam, "MM")} năm {dateCommon.formatDate(KPICaNhan.thangNam, "yyyy")} </label>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col span="24">
                            <div className="card-primary">
                                <Table
                                    className="custom-table-anttd"
                                    dataSource={dataTable}
                                    pagination={false}
                                    bordered
                                    size="small"
                                    columns={columns}
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    summary={() => {
                                        return (
                                            <>
                                                <Table.Summary.Row>
                                                    <Table.Summary.Cell index={0} colSpan={7} align="center"> <label style={{ fontFamily: 'Times New Roman' }}>Cộng (chưa có điểm thưởng)</label> </Table.Summary.Cell>
                                                    <Table.Summary.Cell index={7} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{cong[0]}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={8} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhong && !user.isLanhDaoPhong ? cong[1] : ""}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={9} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhuTrach && cong[2]}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={10} align="center"></Table.Summary.Cell>
                                                </Table.Summary.Row>
                                                <Table.Summary.Row >
                                                    <Table.Summary.Cell index={0} colSpan={7} align="center"> <label style={{ fontFamily: 'Times New Roman' }}>Điểm thưởng</label> </Table.Summary.Cell>
                                                    <Table.Summary.Cell index={7} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{diemThuong[0]}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={8} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhong && !user.isLanhDaoPhong ? diemThuong[1] : ""}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={9} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhuTrach &&diemThuong[2]}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={10} align="center"></Table.Summary.Cell>
                                                </Table.Summary.Row>
                                                <Table.Summary.Row>
                                                    <Table.Summary.Cell index={0} colSpan={7} align="center"> <label style={{ fontFamily: 'Times New Roman' }}>Tổng cộng điểm để xếp loại</label> </Table.Summary.Cell>
                                                    <Table.Summary.Cell index={7} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{layXepLoai(cong[0] + diemThuong[0])}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={8} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhong && !user.isLanhDaoPhong ? layXepLoai(cong[1] + diemThuong[1]) : ""}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={9} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhuTrach && layXepLoai(cong[2] + diemThuong[2])}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={10} align="center"></Table.Summary.Cell>
                                                </Table.Summary.Row>
                                                <Table.Summary.Row style={{ padding:"0px" }}>
                                                    <Table.Summary.Cell index={0} colSpan={7} align="center"> <label style={{ fontFamily: 'Times New Roman' }}>Xếp loại</label> </Table.Summary.Cell>
                                                    <Table.Summary.Cell index={7} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{cong[0]}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={8} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhong && !user.isLanhDaoPhong ? cong[2] : ""}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={9} align="center"><label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan.trangThai > trangThaiKPI.trinhLanhDaoPhuTrach && cong[2]}</label></Table.Summary.Cell>
                                                    <Table.Summary.Cell index={10} align="center"></Table.Summary.Cell>
                                                </Table.Summary.Row>
                                            </>
                                        );
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <div className="print-footer" style={{ marginTop: '25px' }}>
                            <div className="text-center">
                                <Row gutter={8}>
                                    <Col span={12} >
                                    </Col>
                                    <Col span={12}  >
                                        <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>Đà Nẵng, ngày {("0" + now.getDate()).slice(-2)} tháng {("0" + (now.getMonth() + 1)).slice(-2)} năm {now.getFullYear()}</div>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={12} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan.lanhDaoPhong != null ? KPICaNhan.lanhDaoPhong.tenChucVu.toUpperCase() : "LÃNH ĐẠO PHÒNG"}</label>
                                    </Col>
                                    <Col span={12}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>NGƯỜI BÁO CÁO</label>
                                    </Col>
                                </Row>
                            </div>                   
                            <div className="text-center" style={{ paddingTop: "20px" }}>
                            <Row gutter={8}>
                                <Col span={12} >
                                    {
                                        KPICaNhan?.lanhDaoPhong != null ?
                                            <>
                                                <div>Đã ký</div>
                                                <div>{dateCommon.formatDate(KPICaNhan?.lanhDaoPhong.thoiGian, "HH:mm dd/MM/yyyy")}</div>
                                                <br />
                                                <label style={{ fontFamily: 'Times New Roman', marginTop: '20px' }}>{KPICaNhan?.lanhDaoPhong.tenNguoiKy}</label>
                                            </> :
                                            null
                                    }
                                </Col>
                                <Col span={12}  >
                                    {
                                        KPICaNhan?.nguoiBaoCao.thoiGian != null ?
                                            <>
                                                <div>Đã ký</div>
                                                <div>{dateCommon.formatDate(KPICaNhan?.nguoiBaoCao.thoiGian, "HH:mm dd/MM/yyyy")}</div>
                                                <br />
                                                <label style={{ fontFamily: 'Times New Roman', marginTop: '20px' }}>{KPICaNhan?.tenNhanVien}</label>
                                            </> :
                                            <label style={{ fontFamily: 'Times New Roman', marginTop: '100px' }}>{KPICaNhan?.tenNhanVien}</label>
                                    }
                                </Col>
                            </Row>
                            <Row gutter={8}>
                                <Col span={24} >
                                    <label style={{ fontFamily: 'Times New Roman' }}>Ý KIẾN CỦA LÃNH ĐẠO QUỸ</label>
                                </Col>
                            </Row>
                        </div>
                        {KPICaNhan?.lanhDaoQuy != null &&
                            <div className="text-center" style={{ paddingTop: "20px" }}>
                                <Row gutter={8}>
                                    <Col span={24} >
                                        <div>Đã ký</div>
                                        <div>{dateCommon.formatDate(KPICaNhan?.lanhDaoQuy.thoiGian, "HH:mm dd/MM/yyyy")}</div>
                                        <br />
                                        <label style={{ fontFamily: 'Times New Roman' }}>{KPICaNhan?.lanhDaoQuy.tenNguoiKy}</label>
                                    </Col>
                                </Row>
                            </div>
                        }
                        <div style={{ paddingTop: "80px", paddingBottom: "80px" }}>
                            <hr style={{ borderTop: "1px solid", marginTop: "0px", marginBottom: "4px" }} />
                            <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(Bản in chuyển đổi từ Phần mềm quản lý nhân sự tiền lương của Quỹ Đầu tư phát triển thành phố Đà Nẵng)</div>
                            <Row gutter={8} className="text-center" style={{ paddingTop: "10px" }}>
                                <Col span={12} >
                                </Col>
                                <Col span={12}  >
                                    <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>Ngày {("0" + now.getDate()).slice(-2)}/{("0" + (now.getMonth() + 1)).slice(-2)}/{now.getFullYear()}</div>
                                    <label style={{ fontFamily: 'Times New Roman' }}>NGƯỜI CHUYỂN ĐỔI</label>
                                    <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(Ký và ghi rõ họ tên)</div>
                                </Col>
                            </Row>
                        </div>
                    </div>
            </PrintPage>
            </div>
        </section>
    )
}

export default InKPICaNhan;